const TOKEN_RE = /(\d+(?:\.\d+)?(?:\s*[a-zA-Z](?:-[a-zA-Z])?)?(?:\s+(?:bis|ter|quater))?)/i;
export function parseRefs(raw) {
    const s = raw.trim();
    if (!s)
        return [];
    // Walk the string, alternating between matched tokens and text in between.
    const out = [];
    let cursor = 0;
    // Use a global regex variant
    const re = new RegExp(TOKEN_RE.source, 'gi');
    let m;
    while ((m = re.exec(s)) !== null) {
        if (m.index > cursor) {
            out.push({ kind: 'sep', text: s.slice(cursor, m.index) });
        }
        const display = m[0];
        // The article number used for navigation strips the sub-paragraph (e.g. "85.3" → "85"),
        // since articles in the infractions data are keyed by their integer number.
        const art = display.replace(/\s+/g, ' ').replace(/\..*$/, '').trim();
        out.push({ kind: 'art', display, art });
        cursor = m.index + display.length;
    }
    if (cursor < s.length) {
        out.push({ kind: 'sep', text: s.slice(cursor) });
    }
    return out;
}
//# sourceMappingURL=parseRefs.js.map